<template>
  <div class="col-md-4 d-none d-md-block d-lg-block d-xl-block bg-blue">
    <div class="row min-height--100vh align-items-center">
      <!-- <icon :icon="`a-white`" :width="30" :height="30" class="al-logo-main mb-4"></icon> -->

      <div class="col-md-10 offset-md-1 text-center">
        <h1 class="t-700 d-block t-white">AcademicLabs</h1>
        <span class="t-xxlr t-400 t-white">We organise & connect the world of science to accelerate your R&D pipeline</span>
        <br class="mb-4" />
        <!-- <icon v-if="isLogin" :icon="`dashboard`" class="my-5"></icon>
        <icon v-if="isRegister" :icon="`dashboard`" class="my-5"></icon> -->
        <div class="speech-bubble">
          <p class="t-600 mb-0">
            “AcademicLabs <span class="t-blue-dark">saves days of work</span> and allows me to <span class="t-blue-dark">go deeper</span> and conduct more targeted searches than with my old tools.
            <br class="mb-2" />
            I now easily understand who's doing what and get a <span class="t-blue-dark">full picture of the research landscape</span>.”
          </p>
        </div>
        <span class="t-white t-700 mb-4">
          Discovery leader in Biotech scaleup
        </span>
        <div class="speech-bubble">
          <p class="t-600 mb-0">
            “I <span class="t-blue-dark">really enjoy</span> using AcademicLabs. It has been <span class="t-blue-dark">extremely useful</span> in finding opportunities and our experience is <span class="t-blue-dark">far superior</span> to other database companies that we have previously used.
            <br class="mb-2" />
            The filters and analytics are so <span class="t-blue-dark">easy to use</span>, precise and brings back <span class="t-blue-dark">exactly</span> what you are looking for.”
          </p>
        </div>
        <span class="t-white t-700 mb-4">
          Pharma Business Development
        </span>
        <br />
        <router-link
          v-if="showExploreCTA"
          :to="{ name: 'searchHome' }" class="btn btn-large btn-secondary t-600 px-4 my-4">
          Start exploring
        </router-link>

        <!-- <p class="t-white">We bring transparency in the scientific arena to revolutionize research partnering.</p> -->
      </div>
    </div>
  </div>
</template>

<script>
// import Icon from '@/components/shared/Icon'

export default {
  name: 'rightSideText',
  components: {
    // Icon
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    isRegister: {
      type: Boolean,
      default: false
    },
    showExploreCTA: {
      type: Boolean,
      default: true
    }
  }
}
</script>
